module.exports = __webpack_public_path__ + "img/stage-7-motion.f910535a.png";